import React from 'react';

interface IntegrationToggleProps {
  name: string;
  label: string;
  description?: string;
  isSelected: boolean;
  onToggle: () => void;
  icon?: React.ReactNode;
  className?: string;
  showDivider?: boolean;
}

const IntegrationToggle: React.FC<IntegrationToggleProps> = ({ 
  name, 
  label, 
  description, 
  isSelected, 
  onToggle, 
  icon,
  className = "",
  showDivider = false
}) => (
  <button
    type="button"
    className={`flex items-center justify-center px-4 py-3 text-sm font-medium transition-all duration-300 relative ${
      isSelected
        ? "text-white"
        : "bg-white text-slate-700 border border-gray-300 hover:bg-gray-50"
    } ${showDivider ? "border-r border-white" : ""} ${className}`}
    style={{
      backgroundColor: isSelected ? '#010D2C' : undefined
    }}
    onClick={onToggle}
  >
    {label}
  </button>
);

export default IntegrationToggle;
